<div class="card p-3 mb-3"
  [ngClass]="(type === 'measure' && done) ? 'valid' : (type === 'measure' && !done) ? 'invalid' : ''">
  <div class="container py-3" *ngIf="ratingChoice">
    <h4 class="text-left mt-3 mb-3">
      <span *ngIf="isAutoNumber"
        [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-Header' : font === 'K2D' ? 'K2D' : ''">
        {{ ratingChoice.NUMBER }}. {{ ratingChoice.VALUE[0].question }}
      </span>
      <span *ngIf="!isAutoNumber"
        [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-Header' : font === 'K2D' ? 'K2D' : ''">
        {{ questionNumber }}. {{ ratingChoice.VALUE[0].question }}
      </span>
      <!-- {{ ratingChoice.NUMBER }}. {{ ratingChoice.VALUE[0].question }} -->
    </h4>

    <div *ngIf="measureForm">
      <div [ngClass]="detailLength > 6 ? 'areaBottom' : ''">
        <div class="custom-slider">
          <ngx-slider [(ngModel)]="value" [options]="options" (mouseup)="addValue(value)"
            (userChange)="addValue(value)">
          </ngx-slider>
        </div>
      </div>
    </div>

    <div [ngClass]="detailLength > 6 ? 'areaBottom' : ''" *ngIf="!measureForm">
      <div class="custom-slider">
        <ngx-slider [(value)]="value" [options]="options"></ngx-slider>
      </div>
    </div>

  </div>
</div>
